export const commonRoutes = {
    home: "/",
    login: "/"
}
